<template>
  <v-card outlined>
    <v-container style="background-color: rgb(13, 85, 242)">
      <v-row>
        <v-col cols="auto" class="pa-0" align-self="center">
          <v-card-title
            primary-title
            style="text-align: left"
            class="pa-6"
            color="white"
          >
            <span
              style="
                font-family: Inter;
                color: white;
                font-size: 18px;
                line-height: 18px;
              "
            >
              <v-icon small color="white" style="margin-top: -3px"
                >mdi-file-tree</v-icon
              >
              Chains
            </span>
          </v-card-title>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
    </v-container>

    <v-container class="pa-0" style="overflow-x: auto">
      <v-container>
        <v-row class="pa-3" align-content-center>
          <v-col cols="6" class="py-1 d-flex align-center">
            <span
              style="
                font-family: Inter;
                font-size: 0.875rem;
                line-height: 0.875rem;
                font-weight: 600;
              "
              >Chain</span
            >
          </v-col>
          <v-col cols="6" class="py-1">
            <span
              style="
                font-family: Inter;
                font-size: 0.875rem;
                line-height: 0.875rem;
                font-weight: 600;
              "
              >Status</span
            >
          </v-col>
        </v-row>
        <v-row
          v-for="chain in monitoredChains"
          :key="chain.id"
          style="border-top: 0.6px solid rgba(0, 0, 0, 0.12); cursor: pointer"
          class="pa-3 flex-nowrap chain-table-row"
          align-content-center
          @click="openChain(chain)"
        >
          <v-col cols="6" class="py-1 d-flex align-center">
            <v-img
              min-height="16"
              max-width="16"
              contain
              :src="chain.icon"
              class="mr-2"
            ></v-img>
            <span class="chain-name">{{ chain.name }}</span>
          </v-col>
          <v-col cols="6" class="py-1 d-flex align-center">
            <v-icon
              :color="getStatusIconColor(getChainStatus(chain))"
              size="small"
              class="mr-1"
            >
              mdi-circle
            </v-icon>
            <span
              :style="{
                fontFamily: 'Inter',
                fontSize: '0.875rem',
                fontWeight: '400',
                color: getStatusTextColor(getChainStatus(chain)),
              }"
            >
              {{ getChainStatusExplanation(chain) }}
            </span>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { formatChainMetricValue } from '@/services/chainMetricService';

export default {
  props: {
    chains: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['getChainMetric']),
    monitoredChains() {
      return this.chains;
    },
    authStatus() {
      return this.$store.state.auth.status;
    },
  },
  methods: {
    openChain(chain) {
      this.$router.push(`/chain/${chain.id}`);
    },
    getChainStatus(chain) {
      if (chain._dummyStatus) {
        return chain._dummyStatus;
      }
      return this.getChainMetric(chain.id, 'Chain/BpJsonStatus') || 'Loading';
    },
    getChainStatusFormatted(chain) {
      let status = this.getChainStatus(chain);
      if (status == 'Loading') {
        return 'Loading';
      } else {
        return formatChainMetricValue('Chain/BpJsonStatus', status).short;
      }
    },
    getChainStatusExplanation(chain) {
      let status = this.getChainStatus(chain);
      if (status == 'Loading') {
        return 'Loading';
      } else {
        return formatChainMetricValue('Chain/BpJsonStatus', status).long;
      }
    },
    getStatusIconColor(status) {
      const formatted = formatChainMetricValue(
        'Chain/BpJsonStatus',
        status
      ).short;
      switch (formatted) {
        case 'OK':
          return 'hsl(120, 67%, 39%)';
        case 'Warning':
          return 'hsl(40, 87%, 49%)';
        case 'Error':
          return 'hsl(0, 87%, 59%)';
        default:
          return 'hsl(0, 0%, 59%)';
      }
    },
    getStatusTextColor(status) {
      const formatted = formatChainMetricValue(
        'Chain/BpJsonStatus',
        status
      ).short;
      switch (formatted) {
        case 'OK':
          return 'hsl(120, 67%, 39%)';
        case 'Warning':
          return 'hsl(40, 87%, 49%)';
        case 'Error':
          return 'hsl(0, 87%, 59%)';
        default:
          return 'hsl(0, 0%, 59%)';
      }
    },
  },
};
</script>

<style scoped>
.chain-table-row .chain-name {
  font-family: Inter;
  font-size: 0.875rem;
  line-height: 1;
  font-weight: 600;
  vertical-align: middle;
}
</style>
